import { ReactNode, createContext, useContext, useState } from "react"

interface AfterbanksContextType {
  notifications: { id: string; idExterno: string }[]
  addNotification: (notification: { id: string; idExterno: string }) => void
  getNotificationIdCompleted: (id: string) => boolean
  notificationFinishedProcess: (id: string) => void
}

const AfterbanksContext = createContext<AfterbanksContextType | undefined>(
  undefined
)

const AfterbanksNotificationsProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [notifications, setNotifications] = useState<
    { id: string; idExterno: string }[]
  >([])

  const addNotification = (state: { id: string; idExterno: string }) => {
    setNotifications((prev) => [...prev, state])
  }

  const notificationFinishedProcess = (id: string) => {
    setNotifications((prev) =>
      prev.filter((notification) => notification.idExterno !== id)
    )
  }

  const getNotificationIdCompleted = (id: string) => {
    const notificationCompleted = notifications.find(
      (notification) => notification.id === id
    )
    return Boolean(notificationCompleted)
  }

  const value = {
    notifications,
    addNotification,
    getNotificationIdCompleted,
    notificationFinishedProcess,
  }

  return (
    <AfterbanksContext.Provider value={value}>
      {children}
    </AfterbanksContext.Provider>
  )
}

export const useAfterbanksNotifications = () => {
  const context = useContext(AfterbanksContext)
  if (!context) {
    throw new Error("Error con context de afterbanks")
  }
  return context
}

export default AfterbanksNotificationsProvider
